/**
 * 页面终端编码表注册表：按页面终端（B 位）解析编码表。新增页面终端时在
 * SPM_PAGE_CODES 注册即可。
 *
 * global_pc / global_wap 为全局框架组件（Header/Footer/侧边导航/面包屑）的
 * 固定 B 位：这些组件渲染在所有页面，编码与所在页面无关，由
 * scripts/generate-spm-codes.mjs 从 CSV 页面终端行派生（见 codes/global-pc.ts
 * / codes/global-wap.ts 头部说明）。
 *
 * *_app 为 App WebView 内嵌终端：页面结构与 WAP 版一致，B 位 *_wap 重写为
 * *_app、C/D 不变，由生成器从同名 WAP 表全量派生（见 codes/home-app.ts 等头部
 * 说明）。终端归属判定见 reporting/spm/terminal.ts。
 */

import type { SpmPageCodes } from './types';
import { GLOBAL_APP_SPM_CODES } from './codes/global-app';
import { GLOBAL_PC_SPM_CODES } from './codes/global-pc';
import { GLOBAL_WAP_SPM_CODES } from './codes/global-wap';
import { HOME_APP_SPM_CODES } from './codes/home-app';
import { HOME_PC_SPM_CODES } from './codes/home-pc';
import { HOME_WAP_SPM_CODES } from './codes/home-wap';
import { PRODUCT_DETAIL_APP_SPM_CODES } from './codes/product-detail-app';
import { PRODUCT_DETAIL_PC_SPM_CODES } from './codes/product-detail-pc';
import { PRODUCT_DETAIL_WAP_SPM_CODES } from './codes/product-detail-wap';
import { PRODUCT_LIST_APP_SPM_CODES } from './codes/product-list-app';
import { PRODUCT_LIST_PC_SPM_CODES } from './codes/product-list-pc';
import { PRODUCT_LIST_WAP_SPM_CODES } from './codes/product-list-wap';

export type SpmPageId =
  | 'home_pc'
  | 'home_wap'
  | 'home_app'
  | 'product_list_pc'
  | 'product_list_wap'
  | 'product_list_app'
  | 'product_detail_pc'
  | 'product_detail_wap'
  | 'product_detail_app'
  | 'global_pc'
  | 'global_wap'
  | 'global_app';

export const SPM_PAGE_CODES: Record<SpmPageId, SpmPageCodes> = {
  home_pc: HOME_PC_SPM_CODES,
  home_wap: HOME_WAP_SPM_CODES,
  home_app: HOME_APP_SPM_CODES,
  product_list_pc: PRODUCT_LIST_PC_SPM_CODES,
  product_list_wap: PRODUCT_LIST_WAP_SPM_CODES,
  product_list_app: PRODUCT_LIST_APP_SPM_CODES,
  product_detail_pc: PRODUCT_DETAIL_PC_SPM_CODES,
  product_detail_wap: PRODUCT_DETAIL_WAP_SPM_CODES,
  product_detail_app: PRODUCT_DETAIL_APP_SPM_CODES,
  global_pc: GLOBAL_PC_SPM_CODES,
  global_wap: GLOBAL_WAP_SPM_CODES,
  global_app: GLOBAL_APP_SPM_CODES,
};

export function getSpmPageCodes(page: SpmPageId): SpmPageCodes {
  return SPM_PAGE_CODES[page];
}
